/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { rateCalendarUploadActions } from './slice';
import API from './constants';
/**
 * Rate calendar upload generator function to upload rate calendar files
 * @param {*} param0
 */
export function* rateCalendarUploadGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_FORECAST_UPLOAD, payload, true, true);
    yield put(rateCalendarUploadActions.rateCalendarUploadSucceeded(response));
  } catch (error) {
    yield put(rateCalendarUploadActions.rateCalendarUploadFailed(error.message));
  }
}
/**
 * Rate calendar force upload generator function to force upload rate calendar files
 * @param {*} param0
 */
export function* rateCalendarForceUploadGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_FORECAST_FORCE_UPLOAD, payload, true, true);
    yield put(rateCalendarUploadActions.rateCalendarForceUploadSucceeded(response));
  } catch (error) {
    yield put(rateCalendarUploadActions.rateCalendarForceUploadFailed(error.message));
  }
}
//
export function* rateCalendarUploadSaga() {
  yield takeLatest(rateCalendarUploadActions.rateCalendarUpload.type, rateCalendarUploadGenerator);
  yield takeLatest(
    rateCalendarUploadActions.rateCalendarForceUpload.type,
    rateCalendarForceUploadGenerator
  );
}
//
export default rateCalendarUploadSaga;
